import {
  URL_CLASS_PZ_ACADEMY_COM,
  URL_MP_PZ_ACADEMY_COM,
  URL_MP_PZ_ACADEMY_COM_DEV,
  URL_WECHAT_CALLBACK_PZ_ACADEMY_COM,
  APP_ID_OPEN,
  APP_ID_MP,
  APP_ID_OPEN_DEV,
  APP_ID_MP_DEV,
  //STATE_WEB,
  STATE_MP,
} from '@/constants/index';

import {
  getIsWechatBrowser,
  getUrlProtocol,
  getUrlProtocolHost,
  //getIframeParamValue,
} from './browser';

const getWechatAppid = () => {
  const hostname = window.location.host;
  const isWechatBrowser = getIsWechatBrowser();
  if (URL_CLASS_PZ_ACADEMY_COM === hostname) {
    return isWechatBrowser ? APP_ID_MP : APP_ID_OPEN;
  } else {
    return isWechatBrowser ? APP_ID_MP_DEV : APP_ID_OPEN_DEV;
  }
};

const getCallbackOrigin = () => {
  const hostname = window.location.host;
  const isWechatBrowser = getIsWechatBrowser();
  if (URL_CLASS_PZ_ACADEMY_COM === hostname) {
    return isWechatBrowser ? URL_MP_PZ_ACADEMY_COM : URL_WECHAT_CALLBACK_PZ_ACADEMY_COM;
  } else {
    return isWechatBrowser ? URL_MP_PZ_ACADEMY_COM_DEV : URL_WECHAT_CALLBACK_PZ_ACADEMY_COM;
  }
};

const getGwcUriComponent = uri => {
  let gwcRedirect;
  // if (getIframeParamValue('com2cn')) {
  //   gwcRedirect = getUrlProtocol() + 'www.pzacademy.cn'; // + uri;
  // } else {
  gwcRedirect = getUrlProtocolHost() + uri;
  // }
  const gwcUriComponent = '/get-weixin-code.html?redirect_uri=' + encodeURIComponent(gwcRedirect);
  return getUrlProtocol() + getCallbackOrigin() + gwcUriComponent;
};

export const getWechatUrlMp = (url) => {
  const wechatBrowser_redirect_url =
    getUrlProtocol() +
    'open.weixin.qq.com/connect/oauth2/authorize' +
    '?appid=' +
    getWechatAppid() +
    '&redirect_uri=' +
    encodeURIComponent(getGwcUriComponent(url)) +
    '&response_type=code' +
    '&scope=snsapi_userinfo' +
    '&state=' +
    STATE_MP +
    '&connect_redirect=1#wechat_redirect';
  return wechatBrowser_redirect_url;
};
